import _ from 'lodash';
import { User } from 'oidc-client';
import React, { useEffect, useState } from 'react';
import { UserProfileContext } from './UserProfileContext';
import { useUserProfileLoginQuery } from 'api';
import styled from 'themed-components';
import { Box, Button, CircularProgress, createStyles, Grid, makeStyles, Paper, Theme, Typography } from '@material-ui/core';
import userManager from 'lib/auth/UserManager';

interface UserProfileProviderProps {
	b2cId: string;
	token: string;
	children: React.ReactElement | React.ReactElement[];
}
const CriticalError = ({ error }: { error: Error | null }) => {
	const classes = useStyles();
	const onSignoutClick = () => userManager.signoutRedirect();
	return (
		<StyledPaper>
			<Grid xs={6} container item direction="column">
				<Typography className={classes.heading} variant="h3">
					A critical error has occured
				</Typography>
				{!!error && (
					<Typography className={classes.subHeading} variant="h5">
						{error.message}
					</Typography>
				)}
				<Typography className={classes.subHeading} variant="caption">
					You may not have permission to view this page
				</Typography>
				<Grid xs={3} container item direction="column">
					<Button color="primary" variant="contained" onClick={onSignoutClick}>
						Sign out
					</Button>
				</Grid>
			</Grid>
		</StyledPaper>
	);
};
const PageLoader = () => (
	<StyledPaper>
		<CircularProgress />
	</StyledPaper>
);
const useStyles = makeStyles<Theme>((theme) => {
	return createStyles({
		heading: {
			color: `${theme.palette.primary.contrastText}`
		},
		subHeading: {
			color: `${theme.palette.info.dark}`
		}
	});
});
const StyledPaper = styled(Box)`
	padding: 2rem;
	display: flex;
	flex-grow: 1;
	width: 100%;
	height: 100vh;
	justify-content: center;
	align-items: center;
`;

export const UserProfileProvider = ({ b2cId, token, children }: UserProfileProviderProps) => {
	const { data, isLoading, isFetching, error, isError } = useUserProfileLoginQuery(
		{ Authorization: `Bearer ${token}` },
		{ enabled: !!token }
	);
	const profile = _.first(data);
	const user = {
		userId: profile?.userId,
		userProfileId: profile?.userProfileId,
		b2cId,
		token
	};

	if (isLoading || isFetching) return <PageLoader />;
	if (isError) return <CriticalError error={error} />;
	//	return <CriticalError error={new Error('There was an error retrieving your profile.')} />;

	return <UserProfileContext.Provider value={user}>{children}</UserProfileContext.Provider>;
};
